import { useEffect, useState } from 'react';
import UserTypeSelection from './UserTypeSelection';
import ClassSelection from './ClassSelection';
import { get } from '../../Utilities';
import {
  getClientId,
  getClientUserId,
  getRoleArray,
} from '../../redux/reducers/clientUserId.reducer';
import { connect } from 'react-redux';
import { getCurrentBranding } from '../../redux/reducers/branding.reducer';

const FinishSetup = (props) => {
  const { history, clientId, currentBranding, clientUserId, roleArray } = props;
  const [currentStage, setCurrentStage] = useState(
    history?.location?.state?.screen || 'user selection',
  );
  const [targets, setTargets] = useState([]);
  const [selectedRole, setSelectedRole] = useState(roleArray?.length ? roleArray[0] : 1); // 1 for student, 3 for teacher, 6 for institute
  const isTeacher =
    roleArray?.includes(3) || roleArray?.includes(6) || selectedRole === 3 || selectedRole === 6;

  useEffect(() => {
    get(
      { client_id: clientId },
      isTeacher ? '/getTargetBatchesOfMulyankanForTeacher' : '/getTargetBatchesOfMulyankan',
    ).then((res) => {
      if (res && res.success) {
        setTargets(res.result);
      }
    });
  }, [selectedRole]);

  return (
    <div>
      {currentStage === 'user selection' ? (
        <div>
          <UserTypeSelection
            setSelectedRole={setSelectedRole}
            goToClassSelection={() => setCurrentStage('class selection')}
          />
        </div>
      ) : currentStage === 'class selection' ? (
        <ClassSelection
          goToMain={() => history.replace('/')}
          goToUserSelection={() =>
            history?.location?.state?.screen == 'class selection'
              ? history.replace('/mulyankan-profile')
              : setCurrentStage('user selection')
          }
          targets={targets}
          clientId={clientId}
          currentBranding={currentBranding}
          clientUserId={clientUserId}
          selectedRole={selectedRole}
          selectedBatch={history?.location?.state?.current}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientId: getClientId(state),
  clientUserId: getClientUserId(state),
  currentBranding: getCurrentBranding(state),
  roleArray: getRoleArray(state),
});

export default connect(mapStateToProps, null)(FinishSetup);
